import React from 'react';
import s from './SuffixText.scss';
const SuffixText = ({ children })=>/*#__PURE__*/ React.createElement("span", {
        className: s['root']
    }, children);
SuffixText.displayName = 'SuffixText';
export default SuffixText;

//# sourceMappingURL=SuffixText.js.map